module.exports = __webpack_public_path__ + "img/hong2.112ed6df.png";